var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay d-flex"},[_c('div',{staticClass:"m-auto d-flex flex-column"},[_c('LoadingIndicator',{staticClass:"m-auto"}),_c('vue-typer',{staticClass:"m-auto font-weight-bold",attrs:{"text":"Lade ..."}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }